<template>
  <view>
    <view wx:if="{{__mpx_mode__ !== 'web'}}">
      <es-camera
        bindcameraImage="cameraImage"
        cameraStatus="{{state}}"
        wx:class="{{cameraDisplay}}"
      ></es-camera>
    </view>
    <view wx:else>
      <es-clip bindclipImg="clipImage"></es-clip>
      <!-- <view wx:if="{{state}}">
        <es-clip bindclipImg="clipImage"></es-clip>
      </view> -->
    </view>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { AES_ECB_DECRYPT } from '@/common/crypto'
  import { innerRouter, pagePath } from '@/common/jump'

  createComponent({
    props: {
      tickets12306: {
        type: Boolean,
        value: false
      }
    },
    data: {
      reviewStatus: true,
      imageDataBase64: [],
      state: true // 默认人脸审核页面状态
    },

    computed: {
      ...store.mapState({
        userInfo12306: 'login12306.userInfo12306',
        isSmsCode: 'login12306.isSmsCode',
        fullPath: 'login12306.fullPath',
        tickets12306NeedCheck: 'tickets12306.tickets12306NeedCheck'
      }),
      cameraDisplay() {
        return {
          hidden: !this.state
        }
      }
    },

    methods: {
      ...store.mapMutations({
        faceVerificationClose: 'login12306.faceVerification',
        setPhotos12306: 'tickets12306.setPhotos12306'
      }),
      ...store.mapActions({
        faceVerification: 'login12306.faceVerificationAction',
        registerCxVip: 'login12306.registerCxVip',
        get12306TicketsAction: 'tickets12306.get12306TicketsAction',
      }),
      async submit() {
        if (this.tickets12306) {
          this.get12306TicketsAction()
        } else {
          this.faceVerificationClose({
            code: '0'
          })
          if (this.isSmsCode === 4) {
            // 注册畅行会员
            this.registerCxVip({
              images: JSON.stringify(this.imageDataBase64)
            })
          } else {
            // 人脸核验
            this.faceVerification({
              account: this.userInfo12306['account'],
              password: this.userInfo12306?.['password'],
              account_with_star: this.userInfo12306['account_with_star'],
              type: this.userInfo12306['type'],
              images: JSON.stringify(this.imageDataBase64),
              tickets12306NeedCheck: this.tickets12306NeedCheck
            })
          }
          innerRouter.redirect(pagePath().LOGIN12306SUBMIT)
        }
      },
      clipImage(data) {
        // H5 裁剪传过来的数据
        this.state = false
        const base64 = data.detail.imageData.split(',')[1]
        // 如果是查看本人车票触发的人脸核验，需要把图片存下来给接口下次查询使用
        this.tickets12306 && this.setPhotos12306(base64)
        this.imageDataBase64.push(base64)
        this.submit()
      },
      cameraImage(data) {
        // 小程序人脸核验 传过来的数据
        this.state = false
        this.imageDataBase64 = data.detail.imageArr
        this.submit()
      }
    },

    beforeCreate() {},

    created() {},

    mounted() {
      // this.submit()
    },

    destroyed() {}
  })
</script>

<style lang='stylus' scoped>
  .hidden
    display none
</style>
<script name='json'>
  const config = {
    // navigationBarTitleText: '人脸识别',
    usingComponents: {}
  }
  if (__mpx_mode__ !== 'web') {
    config.usingComponents['es-camera'] = '../camera'
  } else {
    config.usingComponents['es-clip'] = '../clip'
  }
  module.exports = config
</script>

